var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusLock20Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#697787"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 8.61108V7.27776V7.27776C8.3335 6.29599 9.12949 5.5 10.1113 5.5V5.5C11.093 5.5 11.889 6.29599 11.889 7.27776V7.27776V8.61108",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 13.5002H7.88888C7.39777 13.5002 7 13.1024 7 12.6113V9.50021C7 9.0091 7.39777 8.61133 7.88888 8.61133H12.3333C12.8244 8.61133 13.2222 9.0091 13.2222 9.50021V12.6113C13.2222 13.1024 12.8244 13.5002 12.3333 13.5002Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusLock20Px);
export default ForwardRef;